<template>
  <div class="row mx-0 slider-container h-100">
    <b-carousel :interval="4000" controls v-if="slides">
      <div  v-if="slide.type == 1" v-for="(slide, index) in slides" :key="index">
        <a :href="slide.link" target="_blank" v-if="slide.link">
          <b-carousel-slide v-lazy-container="{ selector: 'img',loading: require('@/../public/images/icons/main-loader.svg')}">
          <img slot="img" style="display: block"
               class="main-slide-img"
               :data-src="getIcon(slide.images.image)"
               :src="getIcon(slide.images.image)"
               :alt="'VipMagnit Casino '+ slide.title">
              <div class="additional-options"></div>
          </b-carousel-slide>
        </a>
        <b-carousel-slide v-lazy-container="{ selector: 'img',loading: require('@/../public/images/icons/main-loader.svg')}" v-else>
          <img slot="img" style="display: block"
               class="main-slide-img"
               :data-src="getIcon(slide.images.image)"
               :src="getIcon(slide.images.image)"
               :alt="'VipMagnit Casino '+ slide.title">
          <div class="additional-options"></div>
        </b-carousel-slide>
      </div>
    </b-carousel>
  </div>
</template>

<script>
import Config from "@/config";

export default {
  name: 'Slider',
  computed: {
    slides() {
      return this.$store.getters['getSlides']
    }
  },
  methods: {
    getIcon(icon) {
      return  Config.mainStorageUrl + icon
    }
  }
}
</script>

<style>
  .slider-container .carousel-control-prev,
  .slider-container .carousel-control-next{
    width: 100px;
    opacity: 1;
  }
  .slider-container .carousel-control-prev-icon,
  .slider-container .carousel-control-next-icon {
    display: inline-block;
    width: 40px;
    height: 40px;
    opacity: 1;
  }
  .slider-container .carousel{
    max-width : 100%;
  }
  .slider-container .carousel-control-prev-icon,
  .slider-container .carousel-control-next-icon{
    position: relative;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    background-image: linear-gradient(45deg, rgba(230,0,29,1) 0%, rgba(247,81,55,1) 100%) !important;
    border-radius: 50%;
  }
  .slider-container .carousel-control-prev-icon:before{
    content: "\f104";
    font-family: "Font Awesome 5 Free";
    font-size: 25px;
    top: 1px;
    position: absolute;
    left: 35%;
    right: auto;
  }
  .slider-container .carousel-control-next-icon:before{
    content: "\f105";
    display: inline-block;
    font-family: "Font Awesome 5 Free";
    font-size: 25px;
    top: 1px;
    position: absolute;
    left: 41%;
    right: auto;
  }

  .slider-container .carousel-control-prev-icon:after,
  .slider-container .carousel-control-next-icon:after{
    content :"";
    position: absolute;
    background-color: transparent;
    left:-5px;
    right: -5px;
    top :-5px;
    bottom: -5px;
    border: 1px solid #9a9a9a;
    border-radius: 50% ;
  }
  .main-slide-img{
    max-width: 100vw;
    width: 100vw;
    height: calc(100vw/3.82);
  }
  .slider-home-container img[lazy='loading'] {
    object-fit: none !important;
  }
  .slider-container>div{
    width: 100%;
  }

  @media screen and (max-width: 991px) and (min-width: 320px) {
    .slider-container .carousel-control-prev, .slider-container .carousel-control-next {
      display: none;
    }

    .main-slide-img {
      height: calc(100vw/2.82);
      object-fit: cover;
    }
  }
  @media screen and (max-width: 500px) {
    .slider-home-container img[lazy='loading'] {
      object-fit: contain !important;
    }
    .main-slide-img {
      height: calc(100vw/3.82);
    }
    .slider-container .carousel-caption {
      z-index: 0!important;
    }
  }
</style>
